export default __webpack_public_path__ + "static/media/close-icon.7cd0e490.svg";